import { Injectable } from '@angular/core';
import { DocumentStylingElement } from '@models/businessSettings/documentStyles';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './document-styling.actions';

@Injectable({
	providedIn: 'root',
})
export class DocumentStylingDispatch {
	@Dispatch()
	AddStyle = (style: DocumentStylingElement): actions.AddStyle =>
		new actions.AddStyle(style);

	@Dispatch()
	UpdateStyle = (
		id: string,
		style: DocumentStylingElement,
	): actions.UpdateStyle => new actions.UpdateStyle(id, style);
}
